export default __webpack_public_path__ + "static/media/vet-cards.cbed0477.png";